// @flow

import * as React from 'react';
import {useLocation, useArticle} from 'docs/data';
import Box from 'sail/Box';
import Switch from 'sail/Switch';
import type {Article} from 'docs/data';
import {createStripeInternalUrl} from 'docs/util';
import {XRaySidebarLink} from './XRaySidebarLink';

type GatedContentSwitchListProps = {|
  type: 'flag' | 'gate',
  keys: Array<string>,
  article: Article,
|};

export const GatedContentSwitchList = ({
  type,
  keys,
  article,
}: GatedContentSwitchListProps): Array<React.Node> => {
  const {location, replaceLocation} = useLocation();
  const {loadArticle} = useArticle();

  if (!article.xray) {
    return [];
  }

  const key = type === 'gate' ? 'gates' : 'flags';

  const getFromSearchParams = (flagOrGate): boolean => {
    return location.query[`${key}[${flagOrGate}]`] !== 'false';
  };

  const cacheKeys = {
    locale: '',
    country: '',
    merchant: '',
    version: article.version,
  };

  const switches = keys.map((flagOrGate): React.Node => {
    const flagValue = getFromSearchParams(flagOrGate);

    const linkProps =
      type === 'gate'
        ? {
            label: 'View on Admin',
            href: createStripeInternalUrl('gates', {gate: flagOrGate}),
          }
        : {
            label: 'View on Amp',
            href: createStripeInternalUrl('flags', {flag: flagOrGate}),
          };
    return (
      <Box key={flagOrGate} style={{wordBreak: 'break-word'}}>
        <Switch
          onChange={async () => {
            const args = {[`${key}[${flagOrGate}]`]: !flagValue};
            const query = {...location.query, ...args};
            const path = location.derive({query}).toURL().search;
            replaceLocation({query});
            const fullPath = window.location.pathname + path;
            await loadArticle(fullPath, cacheKeys);
          }}
          value={flagValue}
          label={flagOrGate}
          size="small"
          description={<XRaySidebarLink key={flagOrGate} {...linkProps} />}
        />
      </Box>
    );
  });
  return switches;
};
